import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import Signin from './components/auth/Signin';
import LoginCallback from './components/auth/LoginCallback';
import Dashboard from './components/dashboard/Dashboard';
import Issues from './components/issues/Issues';
import PrivateRoute from './components/privateRoute/privateRoute'; // Import the PrivateRoute
import Assigned from './components/assigned/Assigned';
import Logout from './components/logout/Logout';


const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Navigate to="/dashboard" />,
      },
      {
        path: '/signin',
        element: <Signin />,
      },
      {
        path: '/login-callback',
        element: <LoginCallback />,
      },
      {
        path: '/dashboard',
        element: (
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: '/assigned',
        element: (
          <PrivateRoute>
            <Assigned />
          </PrivateRoute>
        ),
      },
      {
        path: '/issues',
        element: (
          <PrivateRoute>
            <Issues />
          </PrivateRoute>
        ),
      },
      {
        path: '/logout', // Add the logout route
        element: <Logout />,
      },
    ],
  },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

